module.exports = __webpack_public_path__ + "static/img/bonusWeek.1b97e12.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bonusWeek.gif
// module id = DbWF
// module chunks = 0